import React from 'react';
import { Redirect } from 'react-router';
import { Paths } from '~admin/route';

export const HomePage: React.FunctionComponent = () => {
  return <Redirect to={Paths.tool.createEvent} />;
};



// WEBPACK FOOTER //
// ./view/pages/home.page.tsx